import React, { useRef, useState } from "react";

const TIPS = [
  "Shift+click checkboxes to select a range of rows.",
  "Select 2+ rows → Merge into one combines requirement text.",
  "Drag the ⋮⋮ handle to reorder rows within the grid.",
  "Save changes persists edits; use Export Excel to review in Excel, then Import Excel to apply changes.",
  "Undo/Redo (Ctrl+Z / Ctrl+Y) works before Save.",
];

export default function RfpHelpPopover() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        className="flex h-8 w-8 items-center justify-center rounded-full border border-slate-300 text-sm font-bold text-slate-600 hover:bg-slate-100 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-800"
        onClick={() => setOpen((v) => !v)}
        aria-label="Grid help"
        title="Tips"
      >
        ?
      </button>
      {open && (
        <>
          <button
            type="button"
            className="fixed inset-0 z-40 cursor-default"
            aria-label="Close help"
            onClick={() => setOpen(false)}
          />
          <div className="absolute right-0 z-50 mt-2 w-72 rounded-xl border border-slate-200 bg-white p-4 text-sm shadow-lg dark:border-slate-700 dark:bg-slate-900">
            <h4 className="mb-2 font-semibold">Quick tips</h4>
            <ul className="list-disc space-y-1.5 pl-4 text-slate-600 dark:text-slate-300">
              {TIPS.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
